export default __webpack_public_path__ + "static/media/icon-select-arrow-small.a04c2646.svg";